<template>
  <div id="wrapper">
    <organization-admin-link-screen/>
  </div>
</template>

<script>
import Vue from 'vue';
import Vuex from 'vuex';

import OrganizationAdminLinkScreen from './OrganizationAdminLinkScreen/OrganizationAdminLinkScreen';

Vue.use(Vuex);
Vue.component('organization-admin-link-screen', OrganizationAdminLinkScreen);

export default {
  name: 'LinkUser',
};
</script>



// WEBPACK FOOTER //
// src/components/LinkUser.vue